import {Component, Input} from '@angular/core';
import {WizardType} from '../../wizard-type.enum';
import {VehicleBrand} from '../../../../../domain/core/vehicle-brand.model';
import {CustomerWizardResponse} from '../../../../../domain/data/customer-wizard-response.data';
import {StripHtmlPipe} from '../../../../../shared/pipes/strip-html.pipe';

@Component({
  selector: 'app-wizard-communication',
  imports: [
    StripHtmlPipe
  ],
  standalone: true,
  templateUrl: './wizard-communication.component.html'
})
export class WizardCommunicationComponent {
  @Input() brand: VehicleBrand;
  @Input() customerWizardResponse: CustomerWizardResponse;

  protected readonly WizardType = WizardType;
  protected readonly VehicleBrand = VehicleBrand;

  getContactEvent(key: string) {
    if (!this.customerWizardResponse?.contactEventList) {
      return null;
    }

    for (const e of this.customerWizardResponse.contactEventList) {
      if (e.eventName === key) {
        return e;
      }
    }
    return null;
  }
}
